import React from "react";

import Dashboard from "@/pages/Dashboard";


export default function CommerceDashboard() {
  return <Dashboard />;
}
